import { OnboardingStep } from 'types/onboardingTypes'

export function getEnergyLevelInfo(): OnboardingStep {
  return {
    id: 'energy_level_info',
    type: 'custom'
  }
}
